import { memo, useRef } from 'react';
import { BzButton, BzInputText, BzModal, BzModalBody, BzModalFooter, BzModalHeader, BzModalTitle } from "../../../components";
import { Container, Row, Col } from "react-bootstrap";



const ConfirmationModal = ({ isShow, setIsShow, setRenameWatchlist, renameWatchlist, activeWatchList, onRenameWatchlist, headerText, isInputBox, bodyText, bodySubText, inputLabel, isButton, buttonData, children, ...props }) => {

    const renameRef = useRef();

    return (
        <div>
            <BzModal show={isShow} className='p-3'>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0 pb-2'>
                            <Col md={11} className='d-flex justify-content-start align-self-center'>
                                <BzModalTitle className='font-medium font-size4 color-text'>{headerText}</BzModalTitle>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-self-center'>
                                <div className='icon-16 icon-close icon-dark' onClick={setIsShow}>&nbsp;</div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody className='bdr-btm'>
                    <Row className='g-0 pb-3'>
                        <Col>
                            <Row className='g-0 pt-2'>
                                <Col className='d-flex justify-content-start align-self-center'>
                                    <div className='font-regular font-size3 color-text'>{bodyText}</div>
                                    <div className='font-medium font-size3 color-text ps-2'>'{bodySubText}'</div>
                                </Col>
                            </Row>

                            {isInputBox ?
                                <>
                                    <Row className='g-0 pt-4'>
                                        <Col>
                                            <div className='font-regular font-size3 color-text pb-2'>{inputLabel}</div>
                                            <BzInputText ref={renameRef} className='font-regular color-text' placeholder='Enter new name here' />
                                        </Col>
                                    </Row>
                                </>
                                :
                                null}
                        </Col>
                    </Row>
                </BzModalBody>

                <BzModalFooter>
                    <div className='d-flex justify-content-end mt-3'>
                        {
                            isButton && buttonData?.length > 0 && buttonData.map((button, i) =>
                                <BzButton key={i} className='btn btn-md btn-primary mx-1' onClick={() => isInputBox ? button.action(renameRef.current.value) : button.action()}>{button.label}</BzButton>)
                        }
                    </div>
                </BzModalFooter>
            </BzModal>
        </div>
    );
};

export default memo(ConfirmationModal);
